const postSites = {
  toastr: 'Added site',
  toastr1: ' has been successfully added',
  toastrError: 'Site already registered',
  toastrError1: 'Enter another name'
};

export default postSites;
